<div class="flex flex-col gap-4">
  @if (form()?.controls?.length) {
    <div class="flex gap-3 flex-wrap">
      @for (control of form()?.controls ?? []; track control.value.id) {
        @if (isKpiRowVisible(control)) {
          <app-expected-kpi
            [form]="control"
            [creatorId]="creatorId()"
            [ctaTemplateId]="ctaTemplateId()"
            [isCustomMode]="isCustomMode()"
            [creators]="creators()"
            [isParentDeleteDisabled]="isParentDeleteDisabled()"
            [isViewMode]="isViewMode()"
          />
        }
      }
    </div>
  }

  @if (availableKpis() === null) {
    <div class="flex flex-wrap gap-3">
      @for (i of [1, 2, 3]; track i) {
        <ngx-skeleton-loader class="h-12" [theme]="{ width: '196px', height: '48px', 'border-radius': '100vw' }" />
      }
    </div>
  }
</div>
